// ── Paleta kolorów FootLog ────────────────────────────────────────────────────
// Pojedyncze źródło prawdy dla kolorów — importuj C zamiast hardkodować hex.
export const C = {
  bg:     "#060a06",
  card:   "#0d130d",
  border: "#1a2a1a",
  green:  "#00ff88",
  lime:   "#a3ff4e",
  red:    "#ff3d6e",
  amber:  "#ffb830",
  blue:   "#3d9eff",
  purple: "#b87fff",
  text:   "#e8f0e8",
  muted:  "#607060",
};
